import { push }        from "connected-react-router";
import React, { FC }   from "react";
import { useDispatch } from "react-redux";
import { Breadcrumb }  from "semantic-ui-react";

interface Props {
  breadcrumbs: { title: string, path: string }[];
}

const Breadcrumbs: FC<Props> = (props: Props) => {
  const dispatch = useDispatch();
  return (
    <>
      <Breadcrumb size="large">
        {
          props.breadcrumbs.map((breadcrumb, index) => (
            <>
              {
                props.breadcrumbs.length - 1 === index
                  ?
                  <>
                    <Breadcrumb.Section active>
                      { breadcrumb.title }
                    </Breadcrumb.Section>
                  </>
                  :
                  <>
                    <Breadcrumb.Section link onClick={ () => dispatch(push(breadcrumb.path)) }>
                      { breadcrumb.title }
                    </Breadcrumb.Section>
                    <Breadcrumb.Divider icon="right angle"/>
                  </>
              }
            </>
          ))
        }
      </Breadcrumb>
    </>
  );
};

export default Breadcrumbs;
